var messages = {
  confirm: 'Confirm',
  noOptions: 'No Data ~',
  noResults: 'No Results ~',
  selectAll: 'All',
  placeholder: 'Please select',
  dunhao: ', ',
  searchPlaceHolder: 'Search',
  reset: 'Reset',
  atLeast: 'Please select at least ${n}',
  addNew: 'Add New'
};
export default messages;